import { AttendancePage } from './attendance/AttendancePage'
import { EmployeesPage } from './employees/EmployeesPage'
import { PermissionsPage } from './permissions/PermissionsPage'

/**
 * `manager-hr` — the staff, their attendance and what each of them may reach.
 *
 * Ported: employees, attendance, permissions. The module is complete.
 */
export const managerHrModule = {
  name: 'manager-hr',
  routes: [
    {
      path: '/employees',
      page: 'employees',
      guard: { permission: 'employees' },
      component: EmployeesPage,
    },
    {
      path: '/attendance',
      page: 'attendance',
      guard: { permission: 'attendance' },
      component: AttendancePage,
    },
    {
      // `main_admin` on read **and** write — `/settings/permissions` is the one settings controller whose
      // GET is not open to an `admin`. The `permissions_admin` flag this was gated on is held by `admin`
      // too in the restored data, so a permission gate would admit somebody the server refuses outright.
      // FB-001 called for this tightening once `manager-settings` swept the module; the route guards are
      // enforced now, so it matters.
      //
      // O119, FRONTEND.md §9.753 - and somebody whose role manages another (`orManagesRoles`, off `/auth/me`): the
      // roles screen is where a delegate edits and assigns the roles they manage, and `GET /settings/roles` answers
      // them their scope (BACKEND.md §10A.408). The lift is the role gate's only; the tier gate is the sidebar
      // entry's own, put here as well so the route keeps it for a delegate and a main administrator alike - every
      // roles endpoint is `@RequireModule("permissions")`.
      path: '/permissions',
      page: 'permissions',
      guard: { systemRoles: ['main_admin'], orManagesRoles: true, franchiseModule: 'permissions' },
      component: PermissionsPage,
    },
  ],
} as const

export { AttendancePage, EmployeesPage, PermissionsPage }
// O119, §9.753 - who the legend's link to *Role a práva* is drawn for; the shell's guard test holds it to the route.
export { mayOpenRolesScreen } from './employees/staff-roster'
// §9.32 — sidebar chrome rather than a route: the shell places it, this module owns it.
export { SidebarAttendance } from './attendance/SidebarAttendance'
export { phaseOf, type Phase } from './attendance/attendance-phase'
// §9.759, FB-1078 - how *Role a práva* titles a right, so the shell's route refusal names it the same way.
export { displayParentOf, permissionLabel } from './permissions/permission-matrix'
